import type { DataTableColumn } from '@core/user-interface-legacy';

export enum CandidateColumnId {
  Name = 'name',
  Note = 'note',
  PositiveRating = 'positive_rating',
  Stages = 'stages',
  JobFitScore = 'job_fit_score',
  Jobs = 'jobs',
  TalentPools = 'talent_pools',
  Tags = 'tags',
  Sources = 'sources',
  CreatedAt = 'created_at',
  NoteCreatedAt = 'note_created_at',
  DeletedAt = 'deleted_at',
  ExpiringIn = 'gdpr_expires_at',
  GdprStatus = 'gdpr_status',
  EEOStatus = 'eeo_status',
  RequestedChange = 'gdpr_uncompleted_change_request_created_at',
  RequestedDelete = 'gdpr_uncompleted_removal_request_created_at',
  DisqualifiedBy = 'disqualified_by',
  DisqualifyDate = 'disqualify_date',
  Integrations = 'integrations',
  LastActivity = 'last_activity_at',
  DeletedBy = 'deleted_by',
  HiredAt = 'hired_at',
  JobStartsAt = 'job_starts_at',
  WorkLocation = 'work_location',
  JobLocationName = 'job_location_name',
  JobLocationAddress = 'job_location_address',
  AiScreening = 'ai_screening',
}

export type CandidateDataTableColumn = DataTableColumn<CandidateColumnId>;
export interface CandidateDataTableColumnWithVisibility extends CandidateDataTableColumn {
  visible: boolean;
}

export enum ViewType {
  // CANDIDATES
  Candidates = 'candidates',
  // Emails = "emails",
  Notes = 'notes',
  AuditLogs = 'auditLogs',
  // Evaluations = "evaluations",
  // Interviews = "interviews",
  GdprExpiringCandidates = 'expiring',
  GdprAwaitingConsentCandidates = 'awaiting_consent',
  GdprRemovalCandidates = 'removal',
  GdprCorrectionCandidates = 'correction',
  RecentlyDeleted = 'recently_deleted',

  // OFFER PIPELINE
  DisqualifiedCandidates = 'disqualified',

  // EEO
  NoEEOData = 'no_eeo_data',
  EEODataRequested = 'eeo_requested',
  Hires = 'hires',
  HireNotes = 'hire_notes',
}

export enum SortByType {
  CreatedAtAsc = 'created_at_asc',
  CreatedAtDesc = 'created_at_desc',
  NoteCreatedAtAsc = 'created_at_asc',
  NoteCreatedAtDesc = 'created_at_desc',
  RelevanceDesc = 'relevance_desc',
  NameAsc = 'candidate_name_asc',
  NameDesc = 'candidate_name_desc',
  NoteAsc = 'candidate_note_asc',
  NoteDesc = 'candidate_note_desc',
  PositiveRatingsAsc = 'candidate_positive_ratings_asc',
  PositiveRatingsDesc = 'candidate_positive_ratings_desc',
  JobTitleAsc = 'candidate_job_title_asc',
  JobTitleDesc = 'candidate_job_title_desc',
  StageNameAsc = 'candidate_stage_name_asc',
  StageNameDesc = 'candidate_stage_name_desc',
  TalentPoolTitleAsc = 'candidate_talent_pool_title_asc',
  TalentPoolTitleDesc = 'candidate_talent_pool_title_desc',
  GdprExpiresAtAsc = 'gdpr_expires_at_asc',
  GdprExpiresAtDesc = 'gdpr_expires_at_desc',
  GdprChangeRequestCreatedAtAsc = 'gdpr_uncompleted_change_request_created_at_asc',
  GdprChangeRequestCreatedAtDesc = 'gdpr_uncompleted_change_request_created_at_desc',
  GdprRemovalRequestCreatedAtAsc = 'gdpr_uncompleted_removal_request_created_at_asc',
  GdprRemovalRequestCreatedAtDesc = 'gdpr_uncompleted_removal_request_created_at_desc',
  LastActivityAsc = 'last_activity_at_asc',
  LastActivityDesc = 'last_activity_at_desc',
  DisqualifiedByAsc = 'disqualified_by_name_asc',
  DisqualifiedByDesc = 'disqualified_by_name_desc',
  DisqualifyDateAsc = 'disqualified_at_asc',
  DisqualifyDateDesc = 'disqualified_at_desc',
  DeletedAtAsc = 'deleted_at_asc',
  DeletedAtDesc = 'deleted_at_desc',
  DeletedByAsc = 'deleted_by_name_asc',
  DeletedByDesc = 'deleted_by_name_desc',
  ScreeningScoreAsc = 'screening_score_asc',
  ScreeningScoreDesc = 'screening_score_desc',
  JobFitScoreAsc = 'job_fit_score_asc',
  JobFitScoreDesc = 'job_fit_score_desc',
  HiredAtAsc = 'hired_at_asc',
  HiredAtDesc = 'hired_at_desc',
  JobStartsAtAsc = 'job_starts_at_asc',
  JobStartsAtDesc = 'job_starts_at_desc',
  PreferredLocationAsc = 'preferred_location_asc',
  PreferredLocationDesc = 'preferred_location_desc',
}

export interface OfferAccessConfig {
  accessControlEnabled: boolean;
  hasAccessToAllOffers?: boolean;
  hasAccessToOfferIds?: number[];
}
